<template>
  <div class="flex items-center my-4 max-w-full" :style="{ width: iframeWidth }">
    <div
      :class="isEnlarge ? 'enlarge' : 'wrapper'"
      :style="{
        top: isEnlarge && clewordNavVisible ? `${setyleNavHeight}px` : '0'
      }"
    >
      <div class="flex h-10 items-center justify-between mx-4">
        <div>
          <slot name="banner-btn" />
          <div v-if="title" class="pr-4 text-white truncate">
            <span>{{ title }}</span>
          </div>
        </div>

        <div class="setting" @click="handleEnlarge">
          <img v-if="isEnlarge" src="./assets/shrink.svg" />
          <img v-else src="./assets/enlarge.svg" />
        </div>
      </div>
      <div
        :class="['iframe relative']"
        :style="{
          height: isEnlarge
            ? clewordNavVisible
              ? `calc(100vh - 2.5rem - ${setyleNavHeight}px)`
              : 'calc(100vh - 2.5rem)'
            : iframeHeight
        }"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IIframewrap } from './type';

const commonMadel = namespace('common');

@Component
export default class IframeWrap extends Vue {
  @Prop() title?: string;
  @Prop() option?: IIframewrap;
  @commonMadel.State('clewordNavVisible') clewordNavVisible: boolean;
  @commonMadel.State('setyleNavHeight') setyleNavHeight: number;

  isEnlarge = false;

  get iframeWidth() {
    let width = '';
    if (this.option?.width) {
      width = this.option?.width + 'px';
    }
    return width;
  }

  get iframeHeight() {
    let height = '';
    if (this.option?.height) {
      height = this.option?.height + 'px';
    }
    return height;
  }

  handleEnlarge() {
    this.isEnlarge = !this.isEnlarge;
    if (!this.isEnlarge) {
      this.$emit('loaded');
    }
  }
}
</script>

<style scoped>
.wrapper {
  @apply w-full md:ml-12 md:mr-12 rounded-motif overflow-hidden shadow-lg;
  /* background-image: linear-gradient(to right, #6f41ef, #9f7ff7); */
  background-color: #6b6981;
  transition: 0.3s;
}
.enlarge {
  @apply fixed left-0 w-screen h-screen z-50;
  background-color: #6b6981;
  transition: 0.3s;
}
.iframe {
  @apply w-full h-120 overflow-hidden bg-white;
}
.iframe > iframe {
  @apply w-full h-full;
  /* 解决固宽后有黑边问题 */
  transform: scaleX(1.004) translateX(0.1%);
}

.setting {
  @apply flex items-center justify-center cursor-pointer hover:opacity-80;
  flex: 0 0 2rem;
}
</style>
